<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a
          {{
            CurrentPageName != "Franchisee_Staff_Create"
              ? "User"
              : "Franchisee Staff"
          }}
          <v-progress-circular
            v-if="isMasterLoading"
            indeterminate
            class="ml-5"
            color="primary"
          ></v-progress-circular>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.middle_name"
                outlined
                label="Middle Name"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.middle_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.last_name"
                outlined
                label="Last Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.gstin"
                outlined
                label="Customer GSTIN"
                hint="Printed on the customer's tax invoices when GST applies"
                maxlength="15"
                prepend-inner-icon="mdi-file-certificate-outline"
                :error-messages="errors.gstin"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                :loading="isMasterLoading"
                ref="position"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
            <v-col
              sm="4"
              v-if="
                CurrentPageName == 'Franchisee_Staff_Create' &&
                !this.$route.query.franchisee_id
              "
            >
              <v-autocomplete
                :loading="isMasterLoading"
                ref="franchisee"
                outlined
                v-model="form.franchisee_id"
                :items="franchiseeItems"
                label="Franchisee *"
                prepend-inner-icon="mdi-store"
                clearable
                :error-messages="errors.franchisee_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>
          <v-btn v-can:edit="'users'"
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save User
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "UserCreatePage",
  data() {
    return {
      form: {
        is_active: true,
        soft_password: "123456",
        password: "123456",
        password_confirmation: "123456",
      },
      companyId: "",
      CurrentPageName: "",
      positionItems: [],
      franchiseeItems: [],
      isDeleteDeviceDialogs: [],
      isDeleteLocationDialogs: [],
      isLoading: false,
      isMasterLoading: false,
      typeItems: [
        { id: "PENDING", text: "PENDING", value: 1 },
        { id: "APPROVED", text: "APPROVED", value: 0 },
      ],
    };
  },
  mounted() {
    this.form.company_id = this.company.id;
    this.form.role_id = "4";
    
    // Set franchisee_id from query parameter if available
    if (this.$route.query.franchisee_id) {
      this.form.franchisee_id = parseInt(this.decryptIt(this.$route.query.franchisee_id));
    }
    
    console.log(this.companyId);
    this.getMasters();
  },
  methods: {
    async getMasters() {
      this.isMasterLoading = true;
      this.CurrentPageName = this.$route.name;
      await axios
        .get(`masters?context=user&franchise_kyc=1&franchisee_status=1`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
          masters.franchisees.forEach((franchisee) => {
            this.franchiseeItems.push({
              id: franchisee.id,
              text: franchisee.name,
              value: franchisee.id,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      await this.fetchPageDetails();
      this.isMasterLoading = false;
    },
    fetchPageDetails() {
      var _this = this;
      if (this.positions) {
        // let customer_posit
        switch (this.$route.name) {
          case "Franchisee_Staff_Create":
            _this.positions = this.positions.filter(
              (item) => item.text !== "CUSTOMER"
            );
            break;

          case "UsersCreaePage":
            break;
          // case "Crew_waiting_for_Internal_Review_Page":
          //   this.filter.on_board_status = "5";
          //   this.filter.position_id = crew_position.id;
          //   break;
          // case "Pending_For_Owner_Crews_Page":
          //   this.filter.on_board_status = "6";
          //   this.filter.position_id = crew_position.id;
          //   break;
          // case "Approved_Crews_Page":
          //   this.filter.on_board_status = "7";
          //   this.filter.position_id = crew_position.id;
          //   break;
          // case "Blacklisted_Crews_Page":
          //   this.filter.on_board_status = 8;
          //   this.filter.position_id = crew_position.id;
          //   break;
          // case "Owner_List_Page":
          //   this.filter.on_board_status = null;
          //   this.filter.position_id = owner_position.id;
          //   break;
          // case "Admin_List_Page":
          //   this.filter.on_board_status = null;
          //   this.filter.position_id = `${admin_position.id},${crew_manager_position.id}`;
          //   break;

          default:
            break;
        }
        this.getData();
      }
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/users", this.form);
        this.isLoading = false;
        await this.saveUserTimestamp(null, this.form);
        if (this.CurrentPageName == "UserCreatePage") {
          this.$router.push("/users");
        } else {
          this.$router.go(-1);
        }
      } catch (e) {
        // alert("error");
        this.isLoading = false;
      }
    },
  },
};
</script>
